import { Service } from '@angular/core';
import { BaseRouteReuseStrategy, type ActivatedRouteSnapshot } from '@angular/router';

/**
 * Страница справочника одна: список, карточка создания и карточка редактирования —
 * маршруты одной страницы, а не разные страницы.
 *
 * По умолчанию роутер при смене маршрута пересоздаёт компонент: список справочника
 * уходит в запрос заново и мигает при открытии и закрытии карточки. Здесь страница
 * переиспользуется, а `url` и `data` маршрута обновляются — карточка открывается
 * поверх живого списка.
 */
@Service()
export class DictionaryRouteReuseStrategy extends BaseRouteReuseStrategy {
    override shouldReuseRoute(
        future: ActivatedRouteSnapshot,
        curr: ActivatedRouteSnapshot,
    ): boolean {
        // Тот же маршрут — поведение роутера по умолчанию.
        if (future.routeConfig === curr.routeConfig) return true;

        // Разные справочники: `data.dictionary` у них разный, страницу не смешиваем.
        const key = future.data?.['dictionary'];

        return typeof key === 'string' && key === curr.data?.['dictionary'];
    }
}
